import produce from 'immer'
import { Reducer } from 'redux';

import { FAQGroup } from 'interfaces/faq';
import { SET_FAQ_GROUP, SET_FAQ_GROUP_MAP, SET_FAQ_EXPANDED_NODE_IDS, SET_FAQ_SCROLL_TO_ID } from 'redux/actions/types'

export interface FQAState {
  group: FAQGroup[];
  groupMap: Map<string, string>|null;
  expandedNodeIds: string[];
  scrollToId:string|null;
}

const initialState:FQAState = {
  group: [],
  groupMap: null,
  expandedNodeIds: [],
  scrollToId: null
}

const faq:Reducer<FQAState, any> = (state = initialState, action:any) => {
  switch (action.type) {
    case SET_FAQ_GROUP:
      return produce(state, draft => {
        draft.group = action.group
      })
    case SET_FAQ_GROUP_MAP:
      return produce(state, draft => {
        draft.groupMap = action.groupMap
      })
    case SET_FAQ_EXPANDED_NODE_IDS:
      return produce(state, draft => {
        draft.expandedNodeIds = action.nodeIds
      })
    case SET_FAQ_SCROLL_TO_ID:
      return produce(state, draft => {
        draft.scrollToId = action.scrollToId
      })
    default:
      return state
  }
}

export default faq
